var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.9 97.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.64,
    cy: 40.24,
    r: 19.64,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.18,
    cy: 20.64,
    r: 19.64,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.27,
    cy: 40.24,
    r: 19.64,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7,75.05l17.53-18.92-1-1L106.51,74.24c-.86-.55-1.76-1.08-2.72-1.59-6.63-3.44-15.43-5.42-24.74-5.52V40.42H77.62V67.13c-9.31.1-18.11,2.08-24.74,5.52a32.77,32.77,0,0,0-4.05,2.4L30.7,56.92l-1,1,18,18c-4.78,3.73-7.4,8.41-7.4,13.38v4.54a3.89,3.89,0,0,0,3.79,3.78H59.18A3.88,3.88,0,0,0,63,93.83V89.29c0-2,3.78-8.07,15.37-8.07S93.71,87,93.71,89.29v4.54a3.88,3.88,0,0,0,3.78,3.78h15.12a3.88,3.88,0,0,0,3.78-3.78V89.29C116.39,83.89,113.3,79,107.7,75.05Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.65,39.74a6,6,0,1,0-6-6A6,6,0,0,0,20.65,39.74Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.64,41.74c-6,0-10,3-10,8.89v2.11h20V50.63C30.64,44.71,26.64,41.74,20.64,41.74Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,20.14a6,6,0,1,0-6-6A6,6,0,0,0,78.19,20.14Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.18,22.14c-6,0-10,3-10,8.89v2.11h20V31C88.18,25.11,84.18,22.14,78.18,22.14Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.28,39.74a6,6,0,1,0-6-6A6,6,0,0,0,136.28,39.74Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,41.74c-6,0-10,3-10,8.89v2.11h20V50.63C146.27,44.71,142.27,41.74,136.27,41.74Z",
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCalls);
export default __webpack_public_path__ + "static/media/phone-calls.091dcc63.svg";
export { ForwardRef as ReactComponent };